import { useUserContext } from "lib/state/UserContextProvider";
import type { ReactNode } from "react";
import { useState } from "react";
import Button from "ui/buttons/Button";
import Link from "ui/components/Link";
import cx from "ui/cx";
import useMediaQuery from "ui/hooks/useMediaQuery";
import IconHamburger from "ui/icons/IconHamburger";
import IconHigharcGrey from "ui/icons/IconHigharcGrey";
import Header from "ui/layouts/Header";
import ActionMenu from "./ActionMenu";
import styles from "./TopNav.module.scss";
import UserMenu from "./UserMenu";

interface TopNavProps {
  logoPath: string;
  leftNav?: ReactNode;
  centerNav?: ReactNode;
  logoToShow?: ReactNode;
  inAdminDashboard?: boolean;
  selectBuilder?: (builderId: string) => void;
  className?: string;
}

export default function TopNav({
  leftNav,
  centerNav,
  logoPath,
  logoToShow,
  inAdminDashboard,
  selectBuilder,
  className,
}: TopNavProps) {
  const { user } = useUserContext();
  const mobile = useMediaQuery("mobile");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const mobileAdminNav = mobile && inAdminDashboard;

  const logo = (
    <Link href={user ? logoPath : "/"} className={styles.logo}>
      {logoToShow ? logoToShow : <IconHigharcGrey />}
    </Link>
  );

  if (mobileAdminNav) {
    return (
      <div className={styles.mobileWrapper}>
        <Header
          className={cx(styles.wrapper, styles.mobileHeader, className)}
          left={
            <div className={styles.mobileLeft}>
              {logo}
              <Button
                btnStyle="tertiary"
                btnSize="small"
                className={styles.mobileMenuButton}
                onClick={() => setMobileMenuOpen((prev) => !prev)}
                aria-label="Toggle navigation"
              >
                <IconHamburger size={12} color="stone" />
              </Button>
            </div>
          }
          right={
            <div className={styles.mobileRight}>
              <ActionMenu />
              <UserMenu {...{ inAdminDashboard, selectBuilder }} showStudioLink />
            </div>
          }
        />
        {mobileMenuOpen && (
          <div className={styles.mobileMenu}>
            <div className={styles.mobileMenuNav}>{leftNav}</div>
          </div>
        )}
      </div>
    );
  }

  return (
    <Header
      className={cx(styles.wrapper, className)}
      left={
        <div className="top-nav-left">
          {logo}
          {leftNav}
        </div>
      }
      center={centerNav && <div className="top-nav-center">{centerNav}</div>}
      right={
        <div className="top-nav-right">
          <ActionMenu />
          <UserMenu {...{ inAdminDashboard, selectBuilder }} showStudioLink />
        </div>
      }
    />
  );
}
